module.exports = __webpack_public_path__ + "img/image6.92a48fac.png";